import React from "react";
import "../css/privacy.scss";

function Cookies() {
  return (
    <div className="privacy">
      <div className="policy-container">
        <h1>Cookie Policy</h1>
        <p>This policy explains how isanroute uses cookies and similar storage technologies on this website.</p>
        <h2>Essential cookies</h2>
        <p>These support core functions such as remembering cart contents, maintaining security and loading requested pages. They cannot be disabled through our site.</p>
        <h2>Preference and analytics cookies</h2>
        <p>If enabled, these remember choices and help us understand aggregated site use. We do not use them to sell personal information.</p>
        <h2>Managing cookies</h2>
        <p>You can block or remove cookies in your browser settings. Blocking essential storage may prevent the cart or checkout from working correctly.</p>
        <h2>Storage duration</h2>
        <p>Essential cart data may remain in your browser until it expires or you clear site data. Any optional analytics data is retained only for a limited period.</p>
        <h2>Third-party services</h2>
        <p>Our hosted payment and delivery services may set their own essential cookies after you leave our checkout. Their policies govern those cookies.</p>
        <h2>Questions</h2>
        <p>For questions about this policy, contact send@isanroute.space.</p>
      </div>
    </div>
  );
}

export default Cookies;
